import * as React from "react";
const IconLogout = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.9863 13.9924L20.2792 12.6995C20.6697 12.309 20.6697 11.6759 20.2792 11.2853L18.9863 9.99243"
      stroke="#e9635e"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9863 11.9924L13.9863 11.9924M4.98633 17.2588V7.25876M16.9863 17.2588C16.9863 18.3633 16.0909 19.2588 14.9863 19.2588H10.9863M16.9863 7.25876C16.9863 6.15419 16.0909 5.25876 14.9863 5.25876H10.9863M5.87693 19.8525L7.87693 21.1858C9.20604 22.0719 10.9863 21.1191 10.9863 19.5217V4.9958C10.9863 3.3984 9.20604 2.44562 7.87693 3.33169L5.87693 4.66503C5.32053 5.03596 4.98633 5.66042 4.98633 6.32913V18.1884C4.98633 18.8571 5.32053 19.4816 5.87693 19.8525Z"
      stroke="#e9635e"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconLogout;
